/**
 * Phase A refactor rôles (2026-09-10) — Source de vérité unique côté frontend
 * pour les libellés + le helper hasRole. Miroir de `backend/auth.py::RoleName`.
 *
 * Aucun composant ne doit comparer `user.role === "admin"` en dur. Utiliser :
 *   - `ROLE_LABEL[user.role]` pour l'affichage
 *   - `hasRole(user, ["admin"])` ou `hasRole(user, ["admin", "secretaire"])`
 *     pour les gates conditionnels.
 *
 * Phase B (2026-09-10) : rôle `gestionnaire_chantier` ajouté.
 */

export const ROLE_LABEL = {
  admin: "Administrateur",
  commercial: "Commercial",
  secretaire: "Secrétaire",
  gestionnaire_chantier: "Gestionnaire de chantier",
};

/**
 * Liste ordonnée des rôles utilisateur système. Utilisée pour populer
 * les <Select> "attribuer / changer un rôle" (page Équipe, etc.).
 *
 * Ordre choisi : le plus permissif (admin) → le plus restreint
 * (gestionnaire_chantier), cohérent avec la lecture UX naturelle.
 *
 * ⚠️ SOURCE-OF-TRUTH miroir de backend/auth.py::RoleName. Un test
 * cross-cutting `backend/tests/roles_source_of_truth_test.py` bloque
 * en CI toute divergence entre ROLES_LIST + ROLE_LABEL frontend et
 * l'enum RoleName backend.
 */
export const ROLES_LIST = [
  "admin",
  "commercial",
  "secretaire",
  "gestionnaire_chantier",
];

/**
 * Retourne true si l'utilisateur a l'un des rôles autorisés.
 *
 * @param {{ role?: string } | null | undefined} user  Objet user (state.user) — peut être null/undefined.
 * @param {string[]} roles                              Liste des rôles autorisés.
 * @returns {boolean}
 */
export function hasRole(user, roles) {
  if (!user || !user.role) return false;
  return roles.includes(user.role);
}
